import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ProjectId } from 'api/models';
import { RootState } from 'data/index';
import { Task } from 'data/tasks';
import { selectTasksByProjectIdSelector } from '../selectors';

/**
 *
 * @deprecated Use `TasksStore.ofId`
 */
export const useTasksByIds = (
  projectId: ProjectId,
  taskIds: number[],
): Task[] => {
  const memoized = useMemo(selectTasksByProjectIdSelector, []);

  return useSelector((state: RootState) => memoized(state, taskIds));
};
